import { render, staticRenderFns } from "./batteryIcon.vue?vue&type=template&id=5113e4b9&scoped=true"
import script from "./batteryIcon.vue?vue&type=script&lang=js"
export * from "./batteryIcon.vue?vue&type=script&lang=js"
import style0 from "./batteryIcon.vue?vue&type=style&index=0&id=5113e4b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5113e4b9",
  null
  
)

export default component.exports